function DownloadPdf() {
  const buttonDownload = document.querySelector('[data-hydro-download-pdf]')

  if (!document.contains(buttonDownload)) {
    console.log('não tem');
    return;
  }

  buttonDownload.addEventListener('click', () => {
    const idReport = document.querySelector('#idRelatorio').value;
    window.location = route('app.settings.integracoes.hydro.download-relatorio-pdf', {'idReport': idReport });
  })
}

module.exports = DownloadPdf;
